<div class="dialogTitle">
  @if (!data.readOnly) {
    <h2>
      {{
      (data.single
      ? "organisations.select.title.single"
      : "organisations.select.title.multi"
      ) | translate
      }}
    </h2>
  }
  @if (data.readOnly) {
    <h2>
      {{ "organisations.title" | translate }}
    </h2>
  }
</div>
<mat-dialog-content>
  <ca-organisation-list-select
    [organisations]="data.organisations"
    [selectedIds]="selectedIds"
    [disabledIds]="data.disabledIds ?? []"
    [single]="data.single"
    [readOnly]="data.readOnly"
    (selectedIdChange)="onSelectedIdChange($event)"
    >
  </ca-organisation-list-select>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="dialogOptions">
    <button
      color="primary"
      [disabled]="!data.readOnly && !selectedIds.length"
      ca-raised-button
      [mat-dialog-close]="selectedIds"
      >
      {{ "organisations.select.done" | translate }}
    </button>

    <!-- Select all/none only available with multi-select -->
    @if (!data.readOnly && !data.single && data.organisations; as orgs) {
      @if (selectedIds.length < (orgs | keyvalue).length) {
        <button
          ca-action-button
          (click)="selectOrgs(orgs)"
          >
          {{ "organisations.select.all" | translate }}
        </button>
      }
      @if (selectedIds.length === (orgs | keyvalue).length) {
        <button
          ca-action-button
          (click)="selectOrgs({})"
          >
          {{ "organisations.select.none" | translate }}
        </button>
      }
    }
  </div>
</mat-dialog-actions>
